module.exports = __webpack_public_path__ + "static/media/scarecrow_false.05246cbd.png";